import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import crsl from "assets/logo/logo.svg";

export default function Footer() {
  return (
    <footer className="csr-footer">
      <div className="csr-footer__top">
        <div className="csr-footer__inner">

          <div className="csr-footer__brand">
            <div className="csr-footer__logo-row">
              <img src={crsl} alt="CSR Associates" className="csr-footer__logo" />
              <div>
                <div className="csr-footer__name">CSR Associates</div>
                <div className="csr-footer__est">Est. 2012 · Bangalore, India</div>
              </div>
            </div>
            <p className="csr-footer__desc">
              Bangalore's most trusted debt recovery and BPO partner. Serving banks,
              NBFCs, and fintechs with ethical, compliant, results-driven collections.
            </p>
            <div className="csr-footer__sachet">
              <a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer">
                🏛️ RBI Sachet Portal — Report a Grievance
              </a>
            </div>
          </div>

          <div className="csr-footer__col">
            <div className="csr-footer__col-title">Navigate</div>
            <ul>
              {[
                ["/", "Home"],
                ["/about", "About Us"],
                ["/channel-partners", "Channel Partners"],
                ["/awards-and-recognitions", "Awards"],
                ["/contact", "Contact Us"],
                ["/careers", "Careers"],
              ].map(([to, label]) => (
                <li key={to}><Link to={to}>{label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="csr-footer__col">
            <div className="csr-footer__col-title">Services</div>
            <ul>
              {["Debt Recovery","Field Collections","Skip Tracing","BPO Services",
                "KPO Services","HR Outsourcing","Loan Recovery","NBFC Collections"].map(s => (
                <li key={s}><Link to="/channel-partners">{s}</Link></li>
              ))}
            </ul>
          </div>

          <div className="csr-footer__col">
            <div className="csr-footer__col-title">Contact</div>
            <div className="csr-footer__contact-items">
              <div className="csr-footer__ci">
                <span className="csr-footer__ci-icon">📍</span>
                <span>No 67, 1st Floor, 5th Cross, 3rd Main, Chamrajpete, Bengaluru – 560018</span>
              </div>
              <div className="csr-footer__ci">
                <span className="csr-footer__ci-icon">📞</span>
                <a href="tel:+9108026601556">080 2660 1556</a>
              </div>
              <div className="csr-footer__ci">
                <span className="csr-footer__ci-icon">✉️</span>
                <a href="mailto:csrassociates2012@gmail.com">csrassociates2012@gmail.com</a>
              </div>
              <div className="csr-footer__ci">
                <span className="csr-footer__ci-icon">🕐</span>
                <span>Mon – Sat: 9:00 AM – 7:00 PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="csr-footer__bottom">
        <div className="csr-footer__bottom-inner">
          <p>© 2025 CSR Associates. All rights reserved. | Bengaluru, Karnataka, India</p>
          <div className="csr-footer__keywords">
            Debt Recovery Bangalore · BPO Services India · Collections Agency Karnataka · NBFC Recovery
          </div>
        </div>
      </div>
    </footer>
  );
}
